import { isProd } from '../constants/variables';

export const GTMID = 'GTM-WZFBDNH';
const GTM_STAGE_ENV = '&gtm_auth=LR2xGwY9YGmjqMxw3m4KNQ&gtm_preview=env-14&gtm_cookies_win=x';

export const buildEnv = isProd ? 'prod' : 'dev';

const GoogleTMConfigurations: {
    dev: string;
    prod: string;
} = {
    prod: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTMID}');`,
    dev: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl+'${GTM_STAGE_ENV}';f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTMID}');`,
};

export const GoogleTMConfiguration = GoogleTMConfigurations[buildEnv] || GoogleTMConfigurations.dev;

export const OptimizeTriggerScript =
    'window.dataLayer = window.dataLayer || []; if (MutationObserver) {new MutationObserver(function() {window.dataLayer.push({ event: `optimize.activate` });}).observe(document.body, {subtree: true,attributes: true,characterData: true,childList: true,});}';

const NoscriptFrameSrc = isProd
    ? `https://www.googletagmanager.com/ns.html?id=${GTMID}`
    : `https://www.googletagmanager.com/ns.html?id=${GTMID + GTM_STAGE_ENV}`;

export const NoscriptFrame = `<iframe height="0" width="0" style="display:none;visibility:hidden;" src="${NoscriptFrameSrc}"></iframe>`;

export const customGA4Id = (id: string) =>
    `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);};gtag('js', new Date());gtag('config', '${id}', {'cookie_flags': 'SameSite=None; Secure'});gtag('set', 'linker',{'accept_incoming': true});gtag('set',["comet_source","comet_network","comet_campaign","comet_ad_group","comet_ad_id","comet_keyword","gad_source","gclid"].reduce((t,k)=>{const v=new URLSearchParams(window.location.search).get(k);if(v){t[k]=v};return t}, {}));`;

export const fbPixelInit = (id: string) =>
    `!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${id}');
  fbq('track', 'PageView');`;
